export default __webpack_public_path__ + "static/media/sxm-logo-blue@2x.5dd8536f.png";